import { Component, OnInit, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { RegisterUserResultModel } from '../models/registerUserResult.model';
import { PreRegistrationModel } from '../models/pre-registration.model';
import { PreRegistrationValidationResult } from '../models/pre-registration-validation.result.model';
import { Action_SetGDPRCOMPLIANCE } from '../state/actions';

@Component({
  selector: 'online-app-pre-registration-gdpr',
  templateUrl: './pre-registration-gdpr.component.html',
  styleUrls: ['./pre-registration-gdpr.component.scss'],
  host: {
    class:'full-view-port-component-with-no-side-nav'
  }
})
export class PreRegistrationGdprComponent implements OnInit {

  preRegistrationGDPRFormGroup: FormGroup;
  isFormSubmitted = false;
  isGDPRAccepted = false;
  sharedStateSubscription: Subscription;
  createdStudent: RegisterUserResultModel;
  preRegistrationDetails: PreRegistrationModel;
  preRegistrationValidationResult: PreRegistrationValidationResult;

  declarationConsents: Array<any> = [];
  enableAgreeButton: boolean = false;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private store: Store<any>) {
    this.declarationConsents.push(
      {
        isAccepted: false,
        text: 'acknowledge that collection of the Requested Personal Data is necessary in order to process the application for study in NSW and for the other the purposes specified above;'
      },
      {
        isAccepted: false,
        text: 'give free and informed consent for DE International (and the other third party processors listed on this form) to use the Requested Personal Data for the purposes listed above; and'
      },
      {
        isAccepted: false,
        text: 'acknowledge it is necessary in order to process the application for study in NSW, and give free and informed consent to DE International, to transfer the Requested Personal Data from the European Union to Australia as set out in this form.'
      }
    );
  }

  ngOnInit() {

    this.sharedStateSubscription = this.store
      .pipe(select('shared'))
      .subscribe(sharedState => {
        if (sharedState) {
          this.preRegistrationDetails = sharedState.preRegistrationDetails;
          this.preRegistrationValidationResult = sharedState.preRegistrationValidationResult;

          if (!this.preRegistrationDetails) {
            this.router.navigate(['pre-registration']);
            return;
          }

          if (!this.preRegistrationValidationResult || !this.preRegistrationValidationResult.IsGdprRequired) {
            this.router.navigate(['/account-registration']);
          }

        } else {
          this.router.navigate(['pre-registration']);
        }
      });

    this.preRegistrationGDPRFormGroup = this.formBuilder.group({
      acceptGDPR: false
    });
  }

  acceptGDPRClicked() {
    this.isGDPRAccepted = !this.isGDPRAccepted;

    this.preRegistrationGDPRFormGroup.patchValue({
      acceptGDPR: this.isGDPRAccepted
    });

    if (this.isGDPRAccepted) {
      this.preRegistrationGDPRFormGroup.get('acceptGDPR').setErrors(null);
    }

    this.preRegistrationGDPRFormGroup.updateValueAndValidity();

  }

  agreeGDPR() {
    this.storeGDPRAcceptance();
    this.router.navigate(['/account-registration']);
  }

  disagreeGDPR() {
    this.router.navigate(['pre-registration']);
  }

  acceptGDPR(): void {

    this.isFormSubmitted = true;
    const gdprAccepted = this.preRegistrationGDPRFormGroup.get('acceptGDPR').value;

    if (gdprAccepted) {
      this.storeGDPRAcceptance();
      this.router.navigate(['/account-registration']);
      // this.router.navigateByUrl('/account-registration');
    } else {
      // this.preRegistrationGDPRFormGroup.get('acceptGDPR').setErrors({'gdprNotAccepted': 'true'});
    }

  }

  storeGDPRAcceptance(): void {
    this.store.dispatch({
      type: Action_SetGDPRCOMPLIANCE,
      payload: true
    });
  }

  onConsentClick(event, declarationConsent: any) {
    declarationConsent.isAccepted = event.checked;
    this.enableAgreeButton = false;
    if (this.declarationConsents.filter(c => !c.isAccepted).length === 0) {
      this.enableAgreeButton = true;
    }
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  // @HostListener('window:popstate', ['$event'])
  // onPopState(event) {
  //   console.log('Back or forward button pressed');
  //   alert('Clicking in back or forward may result in loss of data or unexpected behavior.');
  //   event.preventDefault();

  //   return false;
  // }
}
